import { Waves, Droplets, Baby, Dumbbell, CloudSunRain, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Chapter, Reveal } from "./Chapter";
import { IMAGES } from "../lib/data";

const FEATURES = [
  { icon: Waves, title: "Grand bassin couvert & chauffé", text: "nager par tous les temps, entouré de verdure" },
  { icon: Droplets, title: "Toboggans 3 pistes", text: "des glissades endiablées en famille" },
  { icon: Baby, title: "2 pataugeoires ludiques", text: "mini-toboggan, champignon arroseur, éléphant bleu" },
  { icon: Dumbbell, title: "Aquagym & plages relax", text: "pour les sportifs… et les transats pour les autres" },
];

export default function Piscine() {
  return (
    <section id="piscine" className="relative py-28 lg:py-36 px-6 sm:px-10 lg:px-16 bg-lake text-sand overflow-hidden grain" data-testid="section-piscine">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-pine/30 blur-3xl" />
      <div className="absolute -bottom-32 -left-24 w-[28rem] h-[28rem] rounded-full bg-lakedeep/60 blur-3xl" />

      <div className="relative max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <Chapter num="4" label="L'espace aquatique" dark />
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display font-bold text-4xl sm:text-5xl leading-[1.05] tracking-tight">
              Un <span className="italic font-medium text-gold">plouf</span> au chaud,<br />
              quelle que soit la météo.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-sand/75 text-base lg:text-lg leading-relaxed max-w-lg">
              Notre espace aquatique couvert et chauffé accueille petits et grands toute la saison.
              Après la baignade, place au repos sur les plages agrandies, entre deux activités nature.
            </p>
          </Reveal>

          <div className="mt-10 space-y-3">
            {FEATURES.map((f, i) => (
              <Reveal key={f.title} delay={0.15 + i * 0.08}>
                <div
                  className="flex items-start gap-4 rounded-2xl border border-sand/15 bg-sand/5 backdrop-blur-sm p-4 transition-all duration-300 hover:bg-sand/10 hover:border-sand/30 hover:translate-x-1"
                  data-testid={`piscine-feature-${i}`}
                >
                  <span className="grid place-items-center w-10 h-10 shrink-0 rounded-full bg-gold text-lake">
                    <f.icon size={18} />
                  </span>
                  <div>
                    <div className="font-display font-bold">{f.title}</div>
                    <div className="text-sm text-sand/60">{f.text}</div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="relative h-[540px] hidden md:block">
          <Reveal className="absolute top-0 right-0 w-[64%] rotate-2 z-10" delay={0.15}>
            <img
              src={IMAGES.piscine}
              alt="Piscine couverte chauffée du camping"
              className="rounded-[2rem] w-full h-72 object-cover shadow-2xl shadow-lakedeep"
            />
          </Reveal>
          <Reveal className="absolute top-40 left-0 w-[58%] -rotate-3 z-20" delay={0.3}>
            <img
              src={IMAGES.piscineToboggan}
              alt="Toboggans aquatiques"
              className="rounded-[2rem] border-8 border-sand w-full h-72 object-cover shadow-2xl shadow-lakedeep"
            />
          </Reveal>
          <Reveal className="absolute bottom-0 right-8 z-30" delay={0.45}>
            <span className="font-hand text-3xl text-gold rotate-[-3deg] inline-block">
              bulles de rires & d'eau
            </span>
          </Reveal>
        </div>

        <div className="md:hidden grid grid-cols-2 gap-4">
          <img src={IMAGES.piscine} alt="Piscine couverte" className="rounded-3xl h-44 w-full object-cover -rotate-2" />
          <img src={IMAGES.piscineToboggan} alt="Toboggans" className="rounded-3xl h-44 w-full object-cover rotate-2 mt-6" />
        </div>

        <Reveal delay={0.35}>
          <Link
            to="/que-faire-quand-il-pleut"
            data-testid="piscine-rainy-link"
            className="group mt-12 flex items-center justify-between gap-4 rounded-[1.75rem] border border-sand/15 bg-sand/5 backdrop-blur-sm p-6 transition-all duration-300 hover:bg-sand/10 hover:border-sand/30"
          >
            <div className="flex items-center gap-4">
              <span className="grid place-items-center w-12 h-12 shrink-0 rounded-full bg-gold text-lake transition-transform duration-300 group-hover:-rotate-12">
                <CloudSunRain size={22} />
              </span>
              <div>
                <div className="font-display font-bold text-xl">Et quand il pleut dehors ?</div>
                <p className="text-sm text-sand/65 mt-0.5">
                  4 idées de sorties à moins de 40 minutes : chartreuse, grotte, château…
                </p>
              </div>
            </div>
            <ArrowUpRight size={22} className="text-gold shrink-0 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
